import { useState } from "react";

import { IEvent } from "Bands/types";
import { EventHeader } from "Bands/components";
import { CreateEventForm } from "Bands/containers";
import { useBandContext } from "Bands/contexts";
import { CenterContent, MainContent } from "shared/styles";
import { Card } from "shared/components";
import { CalendarAdd } from "shared/assets/icons";
import { copy } from "shared/assets";
import { Spacer } from "shared/layout";
import { useQueryParam } from "use-query-params";

const eventCopy = copy.event.create;

export const CreateEventPage = () => {
  const [date] = useQueryParam<string>("date");
  const [placeholder, setPlaceholder] = useState<Partial<IEvent>>({
    date,
  });

  const { eventTypes } = useBandContext();

  return (
    <CenterContent>
      <MainContent>
        <Spacer size="l">
          <EventHeader event={placeholder} eventTypes={eventTypes} />
          <Card title={eventCopy.title} icon={CalendarAdd} titleHeading="h2">
            <CreateEventForm
              placeholder={placeholder}
              updatePlaceholder={setPlaceholder}
              eventTypes={eventTypes}
            />
          </Card>
        </Spacer>
      </MainContent>
    </CenterContent>
  );
};
